import React from 'react';
import { withRouter } from  'react-router-dom';
import PropTypes from 'prop-types';

import { compose, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { commonStyles } from '../styles/styles';
import PagePopup from './Popups/PagePopup';
import { toggleFooterPopup } from '../redux/reducers/view';

import { FOOTER_TEXTS } from '../constants';


import { MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody, MDBInput, MDBBtn, MDBIcon, MDBModalFooter } from 'mdbreact';
import ModalPopup from './Popups/ModalPopup';


const Footer = ({ classes, handleTerms,handleClickPAIA, view: { isFooterPopup }, content, titleText, showTerms }) => (
(<div className="grey lighten-2 w-100 pl-2 mt-2 footer">
  <MDBRow className="grey-text w-100" style={{height:30}}>
    <MDBCol size='4' className="pt-2 pl-4 pr-0 no-gutters" >
    <div className={classes.linkStyle}>
      &copy; CPS 2025
    </div>
    </MDBCol>
    <MDBCol size='4' className="pt-2 pl-0 pr-0 center no-gutters" >
      <div
        className={classes.linkStyle}
        onClick={() => handleTerms()}
      >
        Terms &amp; Conditions
      </div>
    </MDBCol>
    <MDBCol size='1' className="pt-2 pl-0 pr-0 center no-gutters" >

      <div
        className={classes.linkStyle}
        onClick={() => handleClickPAIA()}
      >
        PAIA
      </div>
    </MDBCol>
    <MDBCol style={{textAlign: 'right'}} right="true" size='3' className=" pl-0 pt-2 pr-0 no-gutters" >
    <div className={classes.linkStyle}>
      6.2.15
    </div>
    </MDBCol>
  </MDBRow>
</div>)
    
  // <div className={classes.footer} style={{position:'fixed', bottom:0, zIndex: 10000}}>
  //    <div  style={{position:'absolute', bottom:10, right:0}}> <Typography className={`${classes.linkStyleVersion} ${classes.notLink}`}>
  //     Version 1.0.1
  //   </Typography></div>
  //   <Typography className={`${classes.linkStyle} ${classes.notLink}`}>
  //     Copyright RAMPED4 2019
  //   </Typography>
  //   <Typography
  //     className={classes.linkStyle}
  //     onClick={() => handleClick(FOOTER_TEXTS.privacy, 'Privacy Policy')}
  //   >
  //     Privacy policy
  //   </Typography>
  //   <Typography
  //     className={classes.linkStyle}
  //     onClick={() => handleClick(FOOTER_TEXTS.support, 'Terms & Conditions')}
  //   >
  //     Terms &amp; Conditions
  //   </Typography>
  //   {isFooterPopup && (
  //     <PagePopup handlePopupToggle={handleClick} markup={content} title={titleText} />
  //   )}
  // </div>
);

const styles = theme => ({
  ...commonStyles,
  footer: {
    backgroundColor: theme.palette.primary.dark,
    flex: 1,
    bottom: 0,
    position: 'absolute',
    background: 'transparent',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: 40,
  },
  linkStyle: {
    fontSize: 11,
    paddingLeft: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    borderRight: `1px solid ${theme.palette.primary.contrastText}`,
    textDecoration: 'none',
    cursor: 'pointer',
    '&:last-child': {
      borderRight: 'none',
    },
  },
  linkStyleVersion: {
    fontSize: 9,
    paddingLeft: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    borderRight: `1px solid ${theme.palette.primary.contrastText}`,
    textDecoration: 'none',
    cursor: 'pointer',
    '&:last-child': {
      borderRight: 'none',
    },
  },
  notLink: {
    cursor: 'default',
  },
});

const mapStateToProps = state => ({
  view: state.viewReducer,
});

const mapDispatchToProps = dispatch => ({
  toggleFooterPopup: value => dispatch(toggleFooterPopup(value)),
});

export default compose(
 
  withState('content', 'handleContent', null),
  withState('titleText', 'handleTitleText', null),
  withState('showTerms', 'toggleTerms', false),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withHandlers({
    handleClick: props => (content, title) => {
      const {
        view: { isFooterPopup },
        toggleTerms,
        handleContent,
        handleTitleText,
        showTerms
      } = props;
      // if (isFooterPopup) {
      //   toggleFooterPopup(false);
      //   handleContent(null);
      //   handleTitleText(null);
      // } else {
        toggleTerms(!showTerms);
     // }
    },
    handleClickPAIA: props => (content, title) => {
      window.open(process.env.REACT_APP_MY_VAR+'/docs/PAIA.pdf')
    },
  }),
  withStyles(styles),
)(Footer);

Footer.propTypes = {
  classes: PropTypes.instanceOf(Object),
  view: PropTypes.instanceOf(Object),
  handleClick: PropTypes.func,
  content: PropTypes.string,
  titleText: PropTypes.string,
};
